<template>
  <div class="home" ref="menu">
    <div class="position-relative header-wrapper">
      <img src="../assets/serve/1.png" alt="">
      <Header></Header>
      <div class="title-content">
        <div class="big-title animate__animated animate__fadeInDown">{{$t('serve.desc1_1')}}<br> {{$t('serve.desc1_2')}} </div>
        <div class="small-title animate__animated animate__fadeInUp">{{$t('serve.title1')}}</div>
        <img class="animate__animated animate__bounceInUp" src="../assets/serve/down.png" />
      </div>
    </div>
    <div class="serve-wrapper">
      <img class="bg-img" src="../assets/serve/2.png" alt="">
      <div class="serve-content">
        <div class="top-content">
          <div class="serve-title animate__animated animate__fadeInDown">{{$t('serve.desc2')}}</div>
          <div class="serve-desc animate__animated animate__fadeInUp">{{$t('serve.desc3')}}</div>
        </div>
        <div class="img-wrapper">
          <div class="imgs">
            <img src="../assets/serve/book1.png" />
            <div class="desc">{{$t('serve.title2')}}</div>
          </div>
          <div class="imgs">
            <img src="../assets/serve/book2.png" />
            <div class="desc">{{$t('serve.title3')}}</div>
          </div>
          <div class="imgs">
            <img src="../assets/serve/book3.png" />
            <div class="desc">{{$t('serve.title4')}}</div>
          </div>
          <div class="imgs">
            <img src="../assets/serve/book4.png" />
            <div class="desc">{{$t('serve.title5')}}</div>
          </div>
          <div class="imgs">
            <img src="../assets/serve/book5.png" />
            <div class="desc">{{$t('serve.title6')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="productDrawing position-relative">
      <img ref="imgDiv" id="oImg" src="../assets/serve/3.png" alt="">
      <div class="product-content animate__animated">
        <p class="title-top1">{{$t('serve.overseas.title1')}}</p>
        <p class="title-top2">{{$t('serve.overseas.title2')}}</p>
        <div class="overseas">{{$t('serve.overseas.title3')}}</div>
        <div class="overseas">{{$t('serve.overseas.title4')}}</div>
        <div class="overseas">{{$t('serve.overseas.title5')}}</div>
        <div class="overseas">{{$t('serve.overseas.title6')}}</div>
        <div class="overseas">{{$t('serve.overseas.title7')}}</div>
        <div class="overseas">{{$t('serve.overseas.title8')}}</div>
      </div>
      <div class="red_box">{{$t('serve.overseas.title9')}}</div>
    </div>
    <div class="advantage-wrapper position-relative">
      <img class="bg-img" src="../assets/serve/4.png" alt="">
      <div class="advantage-content">
        <div class="advantage-left">
          <div class="fadeInLeft title animate__animated">
            <div class="tt-tt">{{$t('serve.title7')}}</div>
            <div class="desc">
              <div>-{{$t('serve.title8')}}</div>
              <div>-{{$t('serve.title9')}}</div>
              <div>-{{$t('serve.title10')}}</div>
              <div>-{{$t('serve.title11')}}</div>
            </div>
          </div>
        </div>
        <div class="advantage-right">
          <div class="first">
            <img class="zoomIn1 animate__animated" src="../assets/serve/first.png" />
          </div>
          <div class="seconde">
            <img class="zoomIn2 animate__animated" src="../assets/serve/two.png" />
          </div>
          <div class="three">
            <img class="zoomIn3 animate__animated" src="../assets/serve/three.png" />
          </div>
          <div class="five">
            <img class="rotateIn animate__animated" src="../assets/serve/five.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="master-wrapper position-relative">
      <img class="bg-img" src="../assets/serve/5.png" alt="">
      <div class="master-content">
        <div class="top-content">
          <div class="title">PR COMMUNICATION</div>
          <div class="tip-desc">{{$t('serve.communicate.title1')}}</div>
          <div class="line">{{$t('serve.communicate.title2')}}</div>
        </div>
        <div class="swiper">
          <serve-swiper></serve-swiper>
        </div>
        <div class="line-content">
          <div>{{$t('serve.communicate.title3')}}</div>
          <div class="point"></div>
          <div>{{$t('serve.communicate.title4')}}</div>
          <div class="point"></div>
          <div>{{$t('serve.communicate.title5')}}</div>
          <div class="point"></div>
          <div>{{$t('serve.communicate.title6')}}</div>
          <div class="point"></div>
          <div>{{$t('serve.communicate.title7')}}</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
import serveSwiper from "@/components/serve-swiper";
import Header from "@/components/header";
import Footer from "@/components/footer";
  export default {
    components: { serveSwiper, Header, Footer},
    data() {
      return {}
    },
    methods: {

    },
    mounted() {
      const io = new IntersectionObserver(entries => {
        entries.forEach(item => {
          if (item.isIntersecting) {
            if (item.target.classList[0] == 'zoomIn1') {
              item.target.classList.add('animate__zoomIn')
            }
            if (item.target.classList[0] == 'zoomIn2') {
              item.target.classList.add('animate__zoomIn')
            }
            if (item.target.classList[0] == 'zoomIn3') {
              item.target.classList.add('animate__zoomIn')
            }
            if (item.target.classList[0] == 'rotateIn') {
              item.target.classList.add('animate__rotateIn')
            }
            if (item.target.classList[0] == 'fadeInLeft') {
              item.target.classList.add('animate__fadeInLeft')
            }
            if (item.target.classList[0] == 'product-content') {
              item.target.classList.add('animate__fadeInLeft')
            }
          }
        })
      }, {})

      const nodeLists = [...document.querySelectorAll('.animate__animated')]
      nodeLists.forEach(box => {
        io.observe(box)
      })
    }
  }
</script>
<style lang="scss" scoped>
.header-wrapper {
  height: 632px;
}
.title-content {
  width: 100%;
  position: absolute;
  top: 192px;
  left: 0;
  right: 0;
  z-index: 11;
  .big-title {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 67px;
    color: #FFFFFF;
    line-height: 90px;
  }
  .small-title {
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 48px;
    color: #FFFFFF;
    margin-top: 57px;
    line-height: 20px;
  }
  img {
    width: 68px;
    height: 68px;
    margin-top: 36px;
  }
}

.serve-wrapper {
  height: 962px;
  position: relative;
  .serve-content {
    width: 100%;
    height: 100%;
    z-index: 11;
    position: absolute;
    .top-content {
      width: 100%;
      height: 300px;
      font-family: Microsoft YaHei;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .serve-title {
        font-family: SourceHanSansCN;
        font-weight: bold;
        font-size: 50px;
        color: #194299;
        margin-bottom: 26px;
        line-height: 31px;
        height: 48px;
      }
      .serve-desc {
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 21px;
        color: #73788B;
        line-height: 31px;
      }
    }
    .img-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      .imgs {
        margin: 0px 12px;
        img {
          height: 409px;
          transition: transform 0.1s;
          &:hover {
            transform: scale(1.1);
            cursor: pointer;
          }
        }
        .desc {
          margin-top: 55px;
          font-family: SourceHanSansCN;
          font-weight: 400;
          font-size: 32px;
          color: #73788B;
        }
      }
    }
  }
}

.productDrawing {
  width: 100%;
  height: 955px;
  .product-content {
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 293px;
    margin-left: 200px;
    box-sizing: border-box;
    text-align: start;
    p{
      font-size: 46px;
      line-height: 46px;
      color: #d52c41;
    }
    .title-top2 {
      margin-bottom: 72px;
    }
    .overseas {
      font-size: 26px;
      line-height: 26px;
      color: #474649;
      margin-bottom: 26px;
    }
  }
  .red_box {
    width: 296px;
    height: 166px;
    background: #d52c41;
    color: #FFFFFF;
    position: absolute;
    top: 0;
    right: 163px;
    line-height: 166px;
    text-align: center;
  }
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.advantage-wrapper {
  height: 960px;
  background: #F2F2F2;
  .advantage-content {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 11;
    height: 100%;
    .advantage-left {
      font-weight: 800;
      font-size: 52px;
      color: #FFFFFF;
      line-height: 52px;
      position: absolute;
      .title {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        .tt-tt {
          font-family: SourceHanSansCN;
          font-weight: bold;
          font-size: 50px;
          color: #194299;
          margin-bottom: 40px;
          width: 250px;
          text-align: start;
        }
        .desc {
          height: 146px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 27px;
          color: #73788B;
          line-height: 40px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
    .advantage-right {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      .first {
        position: absolute;
        top: 98px;
        left: 700px;
        width: 290px;
        height: 290px;
      }
      .seconde {
        position: absolute;
        top: 110px;
        right: 258px;
        width: 155px;
        height: 155px;
      }
      .three {
        position: absolute;
        top: 586px;
        left: 680px;
        width: 206px;
        height: 206px;
      }
      .five {
        position: absolute;
        top: 265px;
        right: 409px;
        width: 520px;
        height: 520px;
      }
    }
  }
}

.master-wrapper {
  height: 998px;
  font-family: Microsoft YaHei;
  .master-content {
    position: absolute;
    width: 100%;
    z-index: 11;
    .top-content {
      width: 100%;
      height: 100%;
      text-align: center;
      box-sizing: border-box;
      .title {
        font-family: Smartisan Compact CNS;
        font-weight: 800;
        font-size: 85px;
        color: #FFFFFF;
        line-height: 72px;
        margin-top: 165px;
      }
      .tip-desc {
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 50px;
        color: #FFFFFF;
        line-height: 31px;
        margin-top: 37px;
      }
      .line {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 21px;
        color: #FFFFFF;
        line-height: 31px;
        margin-top: 55px;
      }
    }
    .swiper{
      width: 100%;
      padding:  0px 0px 0px 250px;
      z-index: 11;
      height: 432px;
      margin-top: 60px;
      box-sizing: border-box;
    }
    .line-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 27px;
        color: #FFFFFF;
        line-height: 31px;
      }
      .point {
        width: 7px;
        height: 7px;
        background: #FFFFFF;
        border-radius: 50%;
      }
    }
  }
}

.zh {
  .advantage-left {
    left: 280px;
    top: 220px;
  }
  .red_box {
    font-size: 46px;
  }
  .title-top1 {
    margin-bottom: 15px;
  }
  .line-content {
    padding: 0 20%;
  }
}

.en {
  .advantage-left {
    left: 200px;
    top: 220px;
  }
  .red_box {
    font-size: 26px;
  }
  .title-top1 {
    width: 60%;
    line-height: 50px;
    margin-bottom: 0px;
  }
  .title-top2 {
    width: 50%;
    line-height: 50px;
  }
  .line-content {
    padding: 0 8%;
  }
}
</style>
